import { window } from "global";
import React, { useState, useEffect, useRef } from "react";

const PerformanceAnalysisTabs = (props) => {
  const stickyContainerRef = useRef();
  const stickyTabsRef = useRef();
  const { tabsData, sticky, defaultIndex } = props;
  const [selectedIndex, setSelectedIndex] = useState(defaultIndex || 0);
  const [stickyContainerStyle, setStickyContainerStyle] = useState({});
  const [stickyTabsStyle, setStickyTabsStyle] = useState({});

  // useEffect(() => {
  //   const onStickyScroll = (e) => {
  //     if (stickyContainerRef && stickyContainerRef.current) {
  //       const tabsContainerRect = stickyContainerRef.current.getBoundingClientRect();
  //       const tabsRect = stickyTabsRef.current.getBoundingClientRect();
  //
  //       const stickyStyle = {
  //         display: "flex",
  //         justifyContent: "center",
  //         position: "fixed",
  //         zIndex: 99999,
  //         marginTop: 0,
  //         width: "100%",
  //         backgroundColor: "#070720",
  //         boxShadow: "0px 14px 34px 20px rgb(7, 7, 32)"
  //       }
  //       if (document.querySelector(".user-verification-bar")) {
  //         if (tabsContainerRect.top <= 102) {
  //           setStickyContainerStyle({height: tabsContainerRect.height});
  //           setStickyTabsStyle({top: 101, ...stickyStyle});
  //         } else {
  //           setStickyTabsStyle({});
  //         }
  //       } else if (!document.querySelector(".user-verification-bar")) {
  //         if (tabsContainerRect.top <= 62) {
  //           setStickyContainerStyle({height: tabsContainerRect.height});
  //           setStickyTabsStyle({top: 61, ...stickyStyle});
  //         } else {
  //           setStickyTabsStyle({});
  //         }
  //       }
  //     }
  //   }
  //
  //   if (window && sticky) {
  //     window.addEventListener("scroll", onStickyScroll);
  //
  //     return () => window.removeEventListener("scroll", onStickyScroll);
  //   }
  // }, [])

  const finalTabsStyle = { ...stickyTabsStyle, gridTemplateColumns: `repeat(${tabsData.length}, minmax(0px, 1fr))` };

  return (
    <div ref={stickyContainerRef} className="tabs-container" style={stickyContainerStyle}>
      <div ref={stickyTabsRef} className="tabs" style={finalTabsStyle}>
        {tabsData.map((tabData, index) => {
          const selectedStyle = index === selectedIndex ? "chosen" : "";

          return (
            <div
              key={index}
              className={`tab ${selectedStyle}`}
              onClick={() => {
                tabData.callback(tabData.label);
                setSelectedIndex(index);
              }}
            >
              <div className="tabs-text">{tabData.label}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PerformanceAnalysisTabs;
